// True for a shallow push that stays on the page already open — an order's
// tab, a workspace view, a filter written to the query. Nothing new renders,
// so the global route-change chrome (progress bar, scroll-to-top, socket
// re-register) has nothing to do: running it flashed the progress bar and
// jumped the page to the top on every order tab click (Next itself skips the
// scroll for these). `shallow` alone isn't enough — Next reports the caller's
// option even when the push leaves for another page — so the path must also be
// unchanged. Only meaningful at routeChangeStart, while `currentPath` still
// names the page being left.
export const isInPageNav = (url, { shallow } = {}, currentPath) =>
  !!shallow &&
  typeof url === 'string' &&
  typeof currentPath === 'string' &&
  url.split(/[?#]/)[0] === currentPath;
